/**
 * translationEngine.js — binds the reusable i18n engine to the Ticket Dashboard's
 * Firestore cache.
 *
 * The generic auto-translate logic lives in src/i18n (createI18n → useEngine); this
 * file just supplies the shared, cross-device cache collection ('ticketTranslations').
 * Kept separate from i18n.js so that i18n.js stays Firebase-free (and its unit tests
 * need no Firestore). TicketDashboard.js: `const engine = useTranslationEngine();`.
 */
import { createFirestoreCache } from '../../i18n/firestoreCache';
import { useEngine, normTerm } from './i18n';

// One shared cache doc per item, keyed by normalized English name; staff-gated by rules.
const ticketCache = createFirestoreCache('ticketTranslations', normTerm);

export const useTranslationEngine = () => useEngine(ticketCache);
